type Handler<Args extends unknown[]> = (...args: Args) => boolean;

/**
 * Hands a keyboard shortcut to whichever component is mounted to perform it.
 * Handlers return false when they didn't act, so the key goes on to the browser.
 */
export function createShortcutTarget<Args extends unknown[] = []>() {
  const handlers = new Set<Handler<Args>>();
  return {
    register(handler: Handler<Args>): () => void {
      handlers.add(handler);
      return () => {
        handlers.delete(handler);
      };
    },
    call: (...args: Args): boolean => Array.from(handlers).some((handler) => handler(...args)),
  };
}
